<ul class="sg-list" [ngClass]="{'-smaller': size}">
    <li class="sg-list__item" *ngFor="let item of list">
        <mlp-ng-icon [name]="item.left_icon" *ngIf="item.left_icon"></mlp-ng-icon>
        <div [innerHTML]="item.name" class="d-inline"></div>
        <mlp-ng-icon [name]="item.icon" *ngIf="item.icon"></mlp-ng-icon>
    </li>
</ul>
